import Vue from "vue";
import Vant from "vant";
import "vant/lib/index.css";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import dailyCount from "@/utils/dailyCount.js";
// import 'lib-flexible'
// require('promise.prototype.finally').shim();
// import VConsole from "vconsole";
Vue.config.productionTip = false;
// new VConsole();
Vue.use(Vant);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
